<script setup lang="ts">
import type { APIOrderings } from '@/types/api'
interface IProps {
  orderByUpvotes?: boolean
  orderByNewest?: boolean
  orderByUses?: boolean
  orderByCustom?: boolean
}

const {
  orderByUpvotes,
  orderByNewest,
  orderByUses,
  orderByCustom,
} = defineProps<IProps>()

defineOptions({
  name: 'FilterSort',
})

const filters = useFilters()

const sorts = ref<APIOrderings[]>(['saves'])

const selectedSort = ref<APIOrderings>(filters.value.order_by)

onMounted(() => {
  if (orderByUses)
    sorts.value.unshift('uses')

  if (orderByUpvotes)
    sorts.value.unshift('votes')

  if (orderByNewest)
    sorts.value.unshift('newest')

  if (orderByCustom)
    sorts.value.unshift('custom')
})

function changeSort(sort: APIOrderings) {
  filters.value = {
    ...filters.value,
    order_by: sort,
    newest: false,
  }

  selectedSort.value = sort
}
</script>

<template>
  <PopupMenu placement="bottom-end">
    <template #default="{ isShown }">
      <AppButton
        variant="text"
        relative pr-0 pl-0
        class="!text-soft-black"
      >
        <div flex items-center whitespace-nowrap class="gap-[2px] md:gap-1">
          <div i-mdi:sort-variant />
          <div class="<sm:hidden text-[12px] md:text-[14px]">
            {{ formatOrdering(selectedSort) }}
          </div>

          <div i-mdi:chevron-down text-lg duration-125 transform :class="isShown ? '-rotate-180' : 'rotate-0'" />
        </div>
      </AppButton>
    </template>

    <template #content>
      <AppFloatingMenu top-0 left-full>
        <ul>
          <AppFloatingMenuItem
            v-for="sort in sorts"
            :key="sort"
            text-left
            @click="changeSort(sort)"
          >
            <Text>{{ formatOrdering(sort) }}</Text>
          </AppFloatingMenuItem>
        </ul>
      </AppFloatingMenu>
    </template>
  </PopupMenu>
</template>
